export interface AddToCartOptions {
  quantity?: number;
  maxPerCart?: number;
}

interface CartItemSnapshot {
  variant_id?: number;
  quantity?: number;
}

interface CartSnapshot {
  items?: CartItemSnapshot[];
}

async function getCartSnapshot(): Promise<CartSnapshot | null> {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin"
    });
    if (!response.ok) {
      return null;
    }

    return (await response.json()) as CartSnapshot;
  } catch {
    return null;
  }
}

export async function addVariantToCart(
  variantId: string | number,
  options: AddToCartOptions = {}
): Promise<void> {
  const quantity = options.quantity ?? 1;
  const maxPerCart =
    typeof options.maxPerCart === "number" && Number.isFinite(options.maxPerCart)
      ? options.maxPerCart
      : null;
  const numericVariantId = Number(variantId);

  if (maxPerCart !== null && maxPerCart > 0 && Number.isFinite(numericVariantId)) {
    const cartSnapshot = await getCartSnapshot();
    const existingItem = cartSnapshot?.items?.find((item) => item.variant_id === numericVariantId);
    const existingQuantity = Number(existingItem?.quantity ?? 0);
    if (existingQuantity >= maxPerCart) {
      return;
    }
  }

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity })
  });

  if (!response.ok) {
    throw new Error(`Add to cart failed with status ${response.status}`);
  }
}
